import { render } from "./AddNewInstructorsModal.vue?vue&type=template&id=b1ede590&ts=true"
import script from "./AddNewInstructorsModal.vue?vue&type=script&lang=ts"
export * from "./AddNewInstructorsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__